



























































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    name:"IwInputRadioGroup",
    props: {
        radios: {
            type: Array,
            required: true,
            default: [] as Array<Record<string, unknown>>
        },
        defaultValue: {
            type: [String, Boolean],
            required: false,
            default: "" as string
        },
        ariaLabelTooltip: {
            type: String,
            required: false,
            default: ""
        },
        inputLabel: {
            type: String,
            required: true
        },
        inputTooltip: {
            type: Boolean,
            required: false,
            default: false
        },
        inputDescription: {
            type: String,
            required: false,
            default: ""
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: false
        },
        inputRequired: {
            type: Boolean,
            required: false,
            default: false
        },
        inputLabelExtra: {
            type: String,
            required: false,
            default: ""
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        isVisible: {
            type: Boolean,
            required: false,
            default: true
        },
        name: {
            type: String,
            required: true,
            default: "",
        },
        isMultiOption: {
            type: Boolean,
            required: false,
            default: true
        },
        specificId: {
            type: String,
            required: false,
            default: ""
        },
        inputInline: {
            type: Boolean,
            required: false,
            default: false
        },
        labelInline: {
            type: Boolean,
            required: false,
            default: false
        },
        noMargin: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            selectedValues: [] as Array<string|boolean>,
            errors: [] as Array<string>,
            uniqueId: (this.specificId !== "") ? this.specificId : uuidv4() as string
        };
    },
    watch: {
        selectedValues: function(newVal) {
            this.$emit("update-value", newVal[0]);
        }
    },
    created: function() {
        if (this.defaultValue !== null && this.defaultValue !== "") {
            this.selectedValues.push(this.defaultValue);
        }
    },
    methods: {
        triggerCheck: function(val: string | boolean) {
            if (this.disabled) {
                return;
            }
            if(!this.isMultiOption) {
                this.selectedValues = [val];
            } else {
                const index = this.selectedValues.indexOf(val);
                if(index !== -1) {
                    this.selectedValues.splice(index, 1);
                } else {
                    this.selectedValues.push(val);
                }
            }
        },
        checkForm: function() {
            if(this.required && this.selectedValues.length !== 0) {
                this.errors.push(`${this.name} is required ! Please select it`);
            }
        }
    },

});
